var _path, _path2, _path3, _rect, _path4, _rect2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _circle, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path43, _rect10, _rect11, _rect12, _rect13, _path44, _path45, _path46, _path47, _path48, _rect14, _path49, _path50, _path51, _path52, _path53;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicroStern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m339.1,411.19c-4.81,0-8.19-.53-8.48-.57-20.73-2.72-42.78-11.4-57.63-18.19-12.7-5.81-24.55-13.38-35.22-22.48L79.14,234.6c-53.26-39.83-62.65-94.62-62.74-95.17-12.32-56.99,16.77-92.46,17.06-92.81l.2-.24.31-.03c81.44-6.38,144.5,11.95,183.07,28.46,41.81,17.89,64.67,37.58,64.9,37.77l166.52,144.94c25.55,23.29,28.6,37.2,28.82,38.4l7.78,22.98c7.16,24.27-12.56,32.13-12.76,32.21l-114.05,56.67c-6.6,2.74-13.77,3.4-19.16,3.4ZM34.42,47.83c-2.51,3.19-28.18,37.5-16.54,91.32.09.58,9.41,54.79,62.2,94.28l158.67,135.38c10.57,9.01,22.3,16.5,34.87,22.26,14.75,6.75,36.65,15.37,57.22,18.07.17.02,14.78,2.29,26.8-2.71l114.07-56.68c.83-.32,18.68-7.5,11.93-30.39l-7.82-23.13c-.02-.14-2.66-14.17-28.35-37.59l-166.5-144.93c-.22-.2-22.95-19.75-64.57-37.55-38.35-16.4-101.04-34.62-181.98-28.34Z",
    fill: "#292a59",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m470.11,307.48c-.42-1.36-8.44-26.91-33.54-46.39l-134.26-119.37c-.23-.25-23.78-24.46-67.44-47.27-40.27-21.05-106.41-45.21-192.79-40.74l-.39.02-.21.33c-.26.42-26.17,42.69-12.34,86.95.27,1.59,6.3,34.65,36.1,66.77l174.49,152.03c8.05,7.02,16.87,13.14,26.21,18.22,7.03,3.81,14.4,7.37,21.89,10.57,16.54,7.06,34.57,14.01,50.08,14.01,6.85,0,13.2-1.36,18.72-4.66l108.25-53.08c.63-.21,5.81-2.18,8.61-8.52,3.17-7.17,2.03-16.88-3.38-28.87Zm2.02,28.23c-2.63,6-7.72,7.74-7.77,7.76l-108.45,53.16c-8.72,5.22-19.71,5.38-31.46,2.98-.8-.17-1.61-.34-2.41-.53-.2-.04-.39-.09-.59-.14-.31-.07-.61-.14-.92-.23-.1-.01-.2-.04-.3-.07-.49-.12-.98-.24-1.47-.38-2.22-.58-4.45-1.24-6.7-1.96-.39-.12-.77-.25-1.16-.37-7.54-2.48-15.16-5.59-22.48-8.71-7.45-3.18-14.77-6.72-21.76-10.51-9.25-5.02-17.98-11.09-25.95-18.03L66.29,206.7c-30-32.34-35.61-65.65-35.67-65.98l-.02-.11c-13.02-41.55,9.58-81.39,11.97-85.42,85.8-4.36,151.52,19.64,191.56,40.56,43.46,22.7,66.88,46.77,67.15,47.05l134.35,119.45c25.3,19.63,32.99,45.45,33.06,45.7l.04.11c5.24,11.57,6.38,20.88,3.41,27.65Z",
    fill: "#292a59",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m434.41,403.25l-.73-1.31,18.31-10.25c.91-.57,1.74-1.3,2.42-2.17l27.12-47.97,1.31.74-27.21,48.11c-.8,1.03-1.77,1.91-2.88,2.59l-18.33,10.26Z",
    fill: "#292a59",
    strokeWidth: 0
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 361.63,
    y: 419.74,
    width: 76.84,
    height: 1.5,
    transform: "translate(-149.83 234.78) rotate(-27.77)",
    fill: "#292a59",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m330.99,454.94c-.63,0-1.26-.1-1.88-.29l-45.46-14.34c-23.18-8.16-70.32-46.97-70.79-47.36L51.13,238.38c-.43-.42-10.24-10.21-13.37-18.92-.12-.22-15.47-30.73-20.56-76.25l1.49-.17c5.06,45.25,20.29,75.52,20.44,75.82,3.05,8.48,12.94,18.34,13.04,18.44l161.67,154.52c.43.35,47.37,38.99,70.27,47.06l45.44,14.33c1.18.37,2.44.27,3.54-.28l34.06-15.97.64,1.36-34.04,15.96c-.87.43-1.81.66-2.77.66Z",
    fill: "#292a59",
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 317.61,
    y: 431.27,
    width: 45.28,
    height: 1.5,
    transform: "translate(-174.14 626.48) rotate(-72.49)",
    fill: "#292a59",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m67.03,192.72c-8.49-32.09-4.65-71.37,1.65-83.82l-26.87-54.04,1.34-.67,27.21,54.72-.18.34c-6.29,11.85-10.17,51.03-1.7,83.08l-1.45.38Z",
    fill: "#292a59",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m75.03,216.2c-.29-.72-7.05-17.64-8.01-23.55l1.48-.24c.94,5.75,7.86,23.06,7.92,23.23l-1.39.56Z",
    fill: "#292a59",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m449.07,351.13l-1.47.31c-4.15-19.54-17.92-28.91-18.05-29l-.16-.14-1.56-1.83c.31-.25.56-.39.59-.41l.64-.47,1.41,1.67c1.24.87,14.49,10.56,18.6,29.87Z",
    fill: "#292a59",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m422.72,313.61l-.11.09c-.5.14-.96.34-1.37.57l-147.3-140.42c-14.6-15.01-59.8-39.87-87.94-48.39l.43-1.43c28.32,8.57,73.85,33.63,88.57,48.75l147.72,140.83Z",
    fill: "#292a59",
    strokeWidth: 0
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m186.46,125.47c-41.77-11.8-116.23-15.77-116.98-15.81l.08-1.5c.75.04,75.38,4.02,117.31,15.86l-.41,1.44Z",
    fill: "#292a59",
    strokeWidth: 0
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m334.75,331.64l-5.53,9.55c-.98,1.7-1.53,3.64-1.58,5.61l-.68,25.96c-.02.82-.11,1.64-.28,2.45l-.83,4.06-.51-.13c-.7-.17-1.63-.17-1.72.1.05.15.66.54,1.24.75l.45.17-1.87,5.45c-.5,1.68-5.77,6.28-7.33,7.61-.17.14-.29.25-.36.31l-.53.4-.77.58-1.03.77-1.35,1.02c-.39-.12-.77-.25-1.16-.37l4.21-3.18c2.65-2.23,7.01-6.24,7.36-7.45l1.58-4.56c-.69-.32-1.67-.95-1.39-1.81.32-.99,1.65-.96,2.4-.85l.63-3.07c.15-.75.24-1.52.26-2.27l.68-25.97c.05-2.13.65-4.23,1.72-6.08l5.52-9.55.87.5Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m334.28,375.51l-.69,4.11c.24.02.49.05.63.07.89.14,1.82.66,1.75,1.48-.04.4-.28,1.35-1.73,1.45h-.74s-1.43,5.63-1.43,5.63c-.18.86-2.15,2.78-4.9,5.4-.9.85-1.75,1.66-1.99,1.96-.1.12-.19.24-.28.35-.48.64-.97,1.3-1.98,1.75-.05.04-.66.55-1.11.93-.13.11-.25.21-.35.3-.31-.07-.61-.14-.92-.23-.1-.01-.2-.04-.3-.07.04-.03.09-.07.14-.11.23-.19.54-.45.79-.66.35-.29.6-.5.78-.64.43-.36.48-.39.56-.43.77-.35,1.15-.85,1.6-1.44.09-.12.19-.25.29-.38.28-.35,1.07-1.1,2.08-2.06,1.45-1.37,4.47-4.24,4.62-4.89l1.62-6.42h1.49c.72-.04.75-.39.76-.53-.03-.08-.38-.32-.91-.4-.27-.04-1.1-.12-1.1-.12l-.53-.06.87-5.16c.09-.58.15-1.14.17-1.72.12-3.8.6-18.59.78-25.14.06-2.22.7-4.39,1.85-6.28l4.99-8.27.85.52-4.99,8.26c-1.05,1.75-1.64,3.75-1.7,5.79-.18,6.56-.66,21.36-.78,25.15-.02.62-.08,1.24-.19,1.86Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m420.43,326.55c-.1.12-.22.26-.37.4-.45.2-.92.38-1.32.46-.1.02-.2.06-.26.12-1.23,1.09-5.55,4.67-9.56,4.75-.4-.01-1.94-.04-2.64-.12-.37.33-1.24,1.09-1.88,1.41-.51.27-1.15.6-2.04.6-.15,0-.31-.01-.47-.03-.99-.13-1.59-.48-1.78-1.06-.14-.42-.01-.85.18-1.2l-3.2-.25c-.9-.07-23.59-4.36-31.01-5.84-1.45-.28-2.92-.26-4.37.07l-7.72,1.76-.22-.98,7.72-1.76c1.59-.36,3.2-.38,4.79-.07,7.84,1.57,30.07,5.75,30.89,5.82l5.22.41-.8.77c-.27.26-.6.75-.53.96.04.12.32.29.95.37.84.11,1.38-.17,1.91-.44.59-.31,1.54-1.14,1.85-1.43l.2-.19.27.07c.26.06,2.08.13,2.66.13,3.67-.08,7.75-3.46,8.92-4.5.19-.17.44-.29.73-.35.6-.12,1.5-.57,2.13-.92.15.25.15.54-.25,1.04Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m425.63,321.47s-.06-.02-.09-.03c-.04-.01-.08-.02-.12-.02.06-.06.12-.12.17-.16.02.07.03.14.04.21Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m435.54,314.73l-.05.17-6.43,4.69-.64.47s-.28.16-.59.41c-.12.09-.25.21-.39.33-.01.02-.03.03-.05.06-.24.22-.49.49-.69.8l-.04-.03c-.08.07-.19.18-.33.32-.1.08-.21.19-.33.3-2.82,2.65-3.94,3.65-4.3,3.81,0,.01-.78.49-1.64.89.15-.14.27-.28.37-.4.4-.5.4-.79.25-1.04.23-.13.42-.24.54-.32.39-.21,2.3-1.98,3.49-3.11.23-.22.44-.41.6-.56.04-.04.08-.07.11-.1.04,0,.08.01.12.02.03.01.06.01.09.03-.01-.07-.02-.14-.04-.21.29-.27.42-.39.49-.45.01-.02.02-.03.04-.04.11-.16.25-.31.38-.45.38-.4.77-.7,1.04-.88h0c.19-.14.31-.21.33-.22l6.75-4.93c.31-1.19.19-2.25-.36-3.13-1.07-1.72-3.45-2.4-4.19-2.58l-6.41,5.53-.58.5-.11.03c-.2.05-.39.11-.58.18-.58.23-1.09.56-1.48.84-.44-.07-.91-.08-1.4-.03l.1,1s.05-.01.08,0c-.32.16-.67.22-1.01.28-.4.07-.8.14-1.26.36-1.55.75-2.41,2.41-2.42,2.43l-.08.17-.19.07c-1.94.71-1.95,1.63-1.95,1.64v.2s-.13.17-.13.17c-1.87,2.01-3.4,2.41-4.32,2.41-.57,0-.9-.15-.93-.16l-.2-.1-.07-.2c-.25-.8-.73-1.41-1.36-1.7-.35-.17-.64-.2-.88-.08-.43.19-.69.79-.74.99l-.11.36h-.41c-1.36,0-2.78.06-4.03.12-2.02.09-3.61.16-4.34-.05-.19-.04-2.5-.44-5.44-.94-6.56-1.11-17.54-2.98-22.6-3.98-1.71-.34-3.43-.32-5.13.08l-8.01,1.84-.22-.97,8.01-1.85c1.83-.42,3.7-.45,5.55-.08,5.04,1,16.01,2.86,22.57,3.98,4.07.69,5.39.92,5.54.96.57.16,2.25.09,4.03.01,1.17-.05,2.48-.11,3.76-.12.17-.39.53-.98,1.16-1.27.35-.16.95-.27,1.72.09.81.39,1.44,1.11,1.8,2.05.46.07,1.85.09,3.79-1.94.07-.49.44-1.56,2.42-2.33.29-.51,1.22-1.95,2.77-2.7.59-.28,1.11-.37,1.52-.44.51-.09.79-.15,1.01-.4.05-.06.73-.72,1.73-1.26.41-.23.87-.43,1.37-.57l.11-.09,7.07-6.1.23.04c.15.03,3.58.66,5.08,3.07.73,1.18.88,2.56.43,4.11Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m420.92,315.66c-.41.3-.67.56-.68.56-.16.18-.34.31-.53.4h-.01s-.05.01-.08.01l-.1-1c.49-.05.96-.04,1.4.03Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m320.54,398.71c-.1-.01-.2-.04-.3-.07-.49-.12-.98-.24-1.47-.38-1.08-1.05-2.92-2.47-5.35-2.98-.04-.01-.09-.02-.14-.03l.19-.98c.34.06.66.14.98.24,3.12.92,5.18,3.1,5.93,4.02.06.07.11.13.16.18Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m321.38,398.2s-1.58-2.98-6.18-4.21l.26-.97c5.06,1.35,6.74,4.59,6.81,4.73l-.89.45Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m327.48,392.45s-1.56-3.07-6.16-4.3l.26-.97c5.06,1.36,6.73,4.69,6.8,4.83l-.9.44Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m328.5,396.35c-.15.36-.59.79-.93,1.04,0,0-1.39.97-3.11,2.22-.8-.17-1.61-.34-2.41-.53,1.41-1.1,2.82-2.36,4.06-3.64.39-.4.89-.68,1.5-.68.66,0,1.41.34.89,1.59Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m426.5,320.32c.08-.68.13-2.26-.75-3.56-.68-1.01-1.81-1.66-3.35-1.94.19-.07.38-.13.58-.18l.11-.03.58-.5c1.27.42,2.25,1.12,2.91,2.1.74,1.09.95,2.31.96,3.23-.27.18-.66.48-1.04.88Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m427.44,320.8s-.01.06-.01.07h-.04s.04-.05.05-.07Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m425.63,321.47s-.06-.02-.09-.03c-.04-.01-.08-.02-.12-.02-.03.03-.07.06-.11.1-.16.15-.37.34-.6.56-.03-.19-.06-.42-.12-.7-.21-1.13-.72-2.84-1.91-3.87-.79-.68-1.8-.98-2.97-.89h-.01s-.05.01-.08.01l-.1-1c.49-.05.96-.04,1.4.03.91.13,1.73.5,2.42,1.1,1.44,1.25,2.02,3.23,2.25,4.5.02.07.03.14.04.21Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m420.42,327.3l-.96-.29s.85-2.87-.56-4.91c-.87-1.26-2.43-1.99-4.65-2.15l.07-1c2.54.19,4.36,1.06,5.41,2.59,1.67,2.44.72,5.63.68,5.76Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m425.42,321.42s-.07.06-.11.1c-.16.15-.37.34-.6.56-1.19,1.13-3.1,2.9-3.49,3.11-.12.08-.31.19-.54.32-.3-.54-1.2-.92-.05-2.79.4-.65,1.09-.46,2-.73.59-.18,1.18-.54,1.96-.61.25-.03.53-.02.83.04Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m425.14,325.26c-.28.23-.66.36-1.04.44-.26.05-.61.32-.9,1.3-.13.44-.48.87-.99,1.21-2.18,1.43-7.99,5.37-9.92,7.17-.56.54-1.48.84-2.24.68-.41-.09-.71-.3-.63-.76.03-.17.04-.74.34-1.11.35-.42.8-.61,1.19-.85,1.53-.96,7.18-4.47,9.11-6.39.86-.4,1.63-.88,1.64-.89.36-.16,1.48-1.16,4.3-3.81.12-.11.23-.22.33-.3.52.71.37,2.03-1.19,3.31Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m406.47,331.98l-.72-.69c.12-.13,2.96-3.19,1.4-7.37l.94-.35c1.79,4.78-1.47,8.26-1.61,8.41Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m401.56,331.97c-.24,0-.38-.02-.39-.02l.13-.99c.11.01,2.62.31,3.8-2.24h0s.93-2.78-.05-4.34c-.37-.58-.95-.92-1.8-1.02l.12-.99c1.15.14,2,.64,2.53,1.48,1.23,1.97.17,5.11.13,5.24-1.21,2.61-3.55,2.88-4.47,2.88Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m332.52,380.58c-2.74,0-6.98-1.38-7.18-1.45l.31-.95s4.87,1.59,7.35,1.38l.09,1c-.18.02-.37.02-.57.02Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m332.2,382.71c-2.86,0-7.84-1.82-8.08-1.91l.35-.94c1.76.65,6.72,2.23,8.51,1.77l.25.97c-.29.08-.64.11-1.03.11Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m331.53,385.13c-1.31,0-3.86-.28-7.55-1.92l.41-.91c5.15,2.29,7.93,1.78,7.96,1.78l.2.98s-.38.07-1.01.07Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m418.41,327.73l-.98-.18s.43-2.42-.65-3.8c-.47-.6-1.16-.92-2.1-.97l.05-1c1.23.06,2.18.52,2.84,1.35,1.37,1.74.87,4.49.85,4.6Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m434.99,315.22l-.61-.79,3.37-2.61c0-.57-.41-1.76-1.32-2.9-.67-.83-2.08-2.2-4.2-2.28-.61.58-2.34,2.18-2.88,2.49l-.49-.87c.38-.21,1.94-1.64,2.83-2.49l.14-.14h.2c2.64,0,4.38,1.66,5.17,2.65,1.07,1.33,1.71,2.97,1.5,3.9l-.04.18-3.68,2.85Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m435.12,316.79c-.64,0-1.31-.07-2.02-.22l.21-.98c4.79,1.04,7.69-2.2,8.47-4.62,1.17-3.62.77-6.23-1.18-7.77-3.87-3.05-8.39-.58-8.58-.48-3.62,2.21-3.68,7.05-3.68,7.1h-1c0-.22.06-5.45,4.17-7.96.07-.04,5.3-2.92,9.7.55,1.59,1.25,3.14,3.81,1.51,8.86-.78,2.41-3.38,5.51-7.62,5.51Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m293.29,428.59c-2.67,0-4.83-2.17-4.83-4.83s2.17-4.83,4.83-4.83,4.83,2.17,4.83,4.83-2.17,4.83-4.83,4.83Zm0-8.17c-1.84,0-3.33,1.5-3.33,3.33s1.5,3.33,3.33,3.33,3.33-1.5,3.33-3.33-1.5-3.33-3.33-3.33Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 293.29,
    cy: 423.75,
    r: 2.07,
    fill: "#0069b2",
    strokeWidth: 0
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m347.2,317.78c-3.31,0-5.9-1.71-5.9-3.89s2.59-3.89,5.9-3.89,5.9,1.71,5.9,3.89-2.59,3.89-5.9,3.89Zm0-6.77c-2.66,0-4.9,1.32-4.9,2.89s2.25,2.89,4.9,2.89,4.9-1.32,4.9-2.89-2.25-2.89-4.9-2.89Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m347.15,321.66c-3.34,0-5.96-1.72-5.96-3.92h1c0,1.58,2.27,2.92,4.96,2.92s4.96-1.34,4.96-2.92h1c0,2.2-2.62,3.92-5.96,3.92Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m346.65,324.03c-4.49,0-7.55-2.29-7.85-4.52l.99-.13c.25,1.89,3.28,3.82,7.34,3.65,3.47-.14,6.19-1.85,6.19-3.91,0-.68-1.01-1.82-1.35-2.2l.75-.66c.79.89,1.6,1.93,1.6,2.86,0,2.64-3.08,4.75-7.15,4.91-.18,0-.35,0-.53,0Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m346.67,326.08c-4.59,0-7.71-2.29-8.01-4.52l.99-.13c.26,1.89,3.34,3.82,7.52,3.65,3.36-.13,6.01-1.62,6.31-3.54l.99.15c-.38,2.43-3.37,4.23-7.26,4.38-.18,0-.36,0-.54,0Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m339.1,310.19c-1.53,0-3.21-.64-4.35-1.72-.39.11-1.04.25-1.4.26-.84-.03-1.98-.49-2.53-1.04l-4.25-3.88c-.33-.38-.77-.89-.65-1.92.03-.25.21-.69.35-1.01l-6.37-7.21c-.64-.84-.86-1.78-.63-2.67.2-.81.75-1.47,1.53-1.9l.22-.95c.22-.96.89-1.75,1.84-2.19l5.04-2.38c.72-.35,1.6-.44,2.47-.27l1.55.31c1.53-.69,3.62-.1,4.92,1.38l.52.05c.54.05,1.09.35,1.45.79l3.79,4.46c.5.58.61,1.29.29,1.82l4.38,4.87c1.4,1.55,2.34,3.29,2.79,5.17.18.74.61,3.22-1.29,4.28l-7.99,3.42c-.51.2-1.08.3-1.68.3Zm-4.05-2.85l.21.23c1.28,1.36,3.63,2.01,5.13,1.4l7.94-3.4c1.23-.69.89-2.59.76-3.16-.41-1.72-1.27-3.31-2.56-4.74l-4.94-5.49.44-.57c.1-.13.02-.41-.19-.64l-3.8-4.47c-.2-.25-.5-.41-.79-.44l-.93-.09-.13-.16c-1.03-1.28-2.81-1.82-3.98-1.21l-.16.08-1.89-.38c-.66-.13-1.32-.06-1.84.19l-5.05,2.38c-.67.31-1.14.86-1.29,1.51l-.33,1.42-.22.1c-.63.29-1.06.76-1.21,1.35-.15.59,0,1.23.43,1.79l6.78,7.67-.14.3c-.19.41-.38.87-.39.99-.07.59.13.83.41,1.15l4.18,3.8c.39.38,1.3.75,1.88.76.16.01.87-.15,1.37-.3l.3-.09Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m338.09,321.84c-1.32,0-2.69-.61-3.83-1.74-.39.11-1.05.27-1.39.26-.84-.03-1.98-.49-2.53-1.04l-4.38-4.08c-.33-.38-.77-.89-.65-1.92.03-.22.06-.95.08-1.31l-5.97-6.7c-.74-.98-.92-1.8-.67-3.06l.98.2c-.19.97-.08,1.51.46,2.23l6.21,6.97v.2s-.06,1.27-.1,1.58c-.07.59.13.83.41,1.15l4.32,4.02c.39.38,1.29.74,1.88.76.17,0,.87-.15,1.37-.3l.3-.09.21.23c1.35,1.44,3.06,1.99,4.48,1.42l.37.93c-.49.2-1.01.3-1.54.3Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m338.36,324.87c-1.97,0-3.47-.65-4.81-2.04-.46.13-1.24.3-1.66.32-.97-.03-2.28-.58-2.92-1.23l-5.15-4.93c-.37-.44-.88-1.04-.74-2.23.03-.28.08-1.23.09-1.64l-5.79-7.05c-1.07-1.45-1.32-2.97-.74-4.4.67-1.66,2.2-3.13,2.26-3.2l.69.72s-1.44,1.39-2.03,2.85c-.45,1.11-.25,2.26.6,3.42l6.01,7.32v.19c-.01.06-.07,1.52-.12,1.9-.09.77.18,1.08.51,1.48l5.09,4.86c.47.48,1.54.92,2.26.94.26-.02,1.12-.21,1.64-.36l.3-.09.21.23c1.39,1.54,3.05,2.4,6.64,1.67l.2.98c-.94.2-1.79.29-2.56.29Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m339.87,307.32c-1.52,0-3.38-.64-4.49-1.64-.36.09-.93.2-1.21.21-.71-.02-1.54-.37-2.06-.87l-3.15-2.68c-.42-.47-.58-.98-.48-1.45l.36-.92-5.3-5.96c-.15-.19-.29-.36-.43-.52-.58-.69-1.18-1.41-1.08-2.23.06-.43.29-.81.73-1.17.01-.83.18-3.41,1.66-4.65.14-.12.41-.26.96-.53.24-.12.6-.29.68-.35l.64.77c-.13.11-.35.22-.87.48-.25.12-.67.33-.76.4-1.37,1.15-1.3,4.08-1.3,4.11v.27s-.21.16-.21.16c-.32.23-.5.44-.52.64-.05.38.41.93.85,1.46.14.17.29.35.43.52l5.69,6.39-.56,1.41c0,.08.06.27.22.45l3.12,2.65c.37.35.97.6,1.42.62.12,0,.75-.13,1.18-.25l.29-.08.21.22c1.11,1.16,3.73,1.89,4.99,1.39l6.91-2.86c.99-.54.76-1.97.62-2.56l.97-.24c.16.64.54,2.79-1.16,3.71l-6.97,2.89c-.4.15-.87.23-1.38.23Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 346.43,
    y: 307.28,
    width: 6,
    height: 1,
    transform: "translate(28.25 644.93) rotate(-87.76)",
    fill: "#0069b2",
    strokeWidth: 0
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 333.68,
    y: 315.06,
    width: 11.48,
    height: 1,
    transform: "translate(6.39 637.86) rotate(-86.98)",
    fill: "#0069b2",
    strokeWidth: 0
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 328.87,
    y: 313.09,
    width: 11.37,
    height: 1,
    transform: "translate(1.28 628.54) rotate(-86.53)",
    fill: "#0069b2",
    strokeWidth: 0
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 320.2,
    y: 307.34,
    width: 11.78,
    height: 1,
    transform: "translate(.87 616.6) rotate(-86.86)",
    fill: "#0069b2",
    strokeWidth: 0
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 313.35,
    y: 297.11,
    width: 12.03,
    height: 1,
    transform: "translate(11.93 607.53) rotate(-88.21)",
    fill: "#0069b2",
    strokeWidth: 0
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 350.48,
    y: 315.47,
    width: 4.16,
    height: 1,
    transform: "translate(29.09 661.66) rotate(-88.77)",
    fill: "#0069b2",
    strokeWidth: 0
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 340.04,
    y: 315.53,
    width: 3.41,
    height: 1,
    transform: "translate(15.19 647.74) rotate(-88.21)",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m346.56,331.89c-3.34,0-5.96-1.72-5.96-3.92h1c0,1.58,2.27,2.92,4.96,2.92s4.96-1.34,4.96-2.92h1c0,2.2-2.62,3.92-5.96,3.92Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 350.03,
    y: 325.73,
    width: 4.01,
    height: 1,
    transform: "translate(15.64 668.56) rotate(-88.32)",
    fill: "#0069b2",
    strokeWidth: 0
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 339.25,
    y: 325.79,
    width: 3.88,
    height: 1,
    transform: "translate(1.19 653.82) rotate(-87.65)",
    fill: "#0069b2",
    strokeWidth: 0
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 352.03,
    y: 320.25,
    width: 3.63,
    height: 1,
    transform: "translate(25.58 667.63) rotate(-88.77)",
    fill: "#0069b2",
    strokeWidth: 0
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 338.34,
    y: 320.43,
    width: 1.67,
    height: 1,
    transform: "translate(11.04 653.13) rotate(-88.77)",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m328.1,304l-1-.05c0-.07.1-1.77,1.52-2.51l.46.89c-.91.47-.99,1.67-.99,1.68Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m320.65,294.39c-.1-.8.22-2.47,2.1-3.06l.3.95c-1.52.48-1.42,1.83-1.41,1.99l-.99.12Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m331.55,307.81c0-.1-.15-2.38,1.67-3.28l.45.89c-1.22.61-1.12,2.3-1.12,2.32l-1,.07Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m338.63,310.12l-.79-.62c.84-1.07.04-2.56.03-2.58l.87-.49c.05.08,1.15,2.09-.12,3.68Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m348.69,306.37l-.9-.43c.45-.95-.49-1.96-.5-1.97l.73-.68c.06.06,1.41,1.53.67,3.09Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 337,
    y: 320.54,
    width: 1,
    height: 10.02,
    transform: "translate(-129.52 367.78) rotate(-49.14)",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m344.32,333.44c-.18,0-.37-.01-.57-.05l.15-.99c.57.09,1.02,0,1.29-.23.3-.26.37-.69.37-1h1c0,.75-.25,1.35-.72,1.76-.28.24-.76.5-1.52.5Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m334.78,328.5c-1.11-.55-1.55-1.1-1.63-2.05-.17-1.89.36-3.75.38-3.82l.96.27s-.49,1.76-.34,3.46c.04.51.21.81,1.08,1.24l-.44.9Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m342.41,334.46c-.35,0-.63-.05-.7-.06l.19-.98c.4.08,1.11.07,1.34-.18.12-.13.1-.38.05-.6-.5-.57-3.67-3.99-7.77-4.09-.79-.04-2.14.24-2.38.76-.17.37.25.95.53,1.27.39.45,1.03.61,1.04.61l-.22.98s-.97-.22-1.58-.93c-.76-.89-.99-1.68-.67-2.35.65-1.37,3.2-1.33,3.31-1.33,4.91.11,8.44,4.35,8.59,4.53l.09.18c.25.86,0,1.37-.25,1.65-.41.45-1.06.55-1.56.55Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m341.47,335.21c-.2,0-.36-.02-.43-.03l.16-.99c.3.04.64,0,.71-.07h0s.02-.12-.14-.44c-.91-1.72-2.25-3.33-5.93-3.41-.88-.03-1.99.21-2.16.57-.08.17.07.5.4.88l-.76.65c-.63-.73-.81-1.39-.55-1.96.54-1.14,2.66-1.15,3.09-1.14,4.23.1,5.85,2.16,6.79,3.94.32.61.34,1.11.07,1.49-.3.42-.85.5-1.25.5Z",
    fill: "#0069b2",
    strokeWidth: 0
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m352.94,329.33c-.42,0-.81-.2-1.03-.37l.61-.79c.09.07.37.22.51.14.08-.05.78-.63-.06-5.02l.98-.19c.68,3.55.56,5.48-.4,6.07-.2.12-.41.17-.61.17Z",
    fill: "#0069b2",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroStern);
export default __webpack_public_path__ + "static/media/MicroStern.c942028b58f0ab2503d1ee25181877e2.svg";
export { ForwardRef as ReactComponent };